<template>
  <div id="example" class="example">
    <a-spin/>
  </div>
</template>

<script>
export default {
 name:'loading',
 data () {
 return {
 };
 },
 mounted() {
    const height = window.innerHeight - (44 + 54)
   const ele = document.getElementById('example')
    ele.style.height = height - 32 + 'px'
 }
}
</script>
<style scoped lang="less">
.example {
  text-align: center;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
  margin: auto;
  width: 840px;
  background: #ffffff;
  overflow-y: auto;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
}
</style>